import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { ProcessSteps } from '../shared/ProcessSteps';
import { Reveal } from '../shared/Reveal';
import { SectionHeading } from '../shared/SectionHeading';
import { useLanguage } from '../../contexts/LanguageContext';
export function ProcessTeaser() {
  const {
    t
  } = useLanguage();
  return <section aria-labelledby="process-title" className="bg-cream py-20 sm:py-24" data-id="element-44" data-mp="2i7yh11g7dc3x">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-45" data-mp="2i63rf9tzkvti">
        <Reveal data-id="element-46" data-mp="2n82tmgdzpmov">
          <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-47" data-mp="2n7jawxgimu9s">
            <SectionHeading id="process-title" title={t.home.process.title} description={t.home.process.description} data-id="element-48" data-mp="2s531mwuegzim" />
            <Link to="/process" className="group inline-flex items-center gap-2 text-sm font-medium text-mauve" data-id="element-49" data-mp="2wydz47dbo3xv">
              {t.home.process.cta}
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-smooth group-hover:translate-x-1" data-id="element-50" data-mp="24ga4wy5yenmy" />
            </Link>
          </div>
        </Reveal>
        <div className="mt-12" data-id="element-51" data-mp="su75qz9x216l">
          <ProcessSteps layout="row" data-id="element-52" data-mp="nshq16br0zc6" />
        </div>
      </div>
    </section>;
}